<template>
  <div>
    aa
    <video id="videoElement" crossorigin="anonymous" style="height: 0px" autoplay>
      <source :src="effectVideoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div style="background-color: black">
      <canvas class="b-red" id="canvasElement"></canvas>
    </div>
  </div>
</template>

<script>
import { buildResourceUrl } from "@/constants";

// 방식 두가지
// 1 video를 재생하면서 canvas에 그리기
// 2 gif로 미리 만들어 놓기
// 성능이슈가 없으면 그냥 1번 방법으로 잘 해보자
export default {
  computed: {
    effectVideoUrl() {
      return buildResourceUrl("effect/e.mp4");
    },
  },
  mounted() {
    var video = document.getElementById("videoElement");
    var canvas = document.getElementById("canvasElement");
    var context = canvas.getContext("2d");

    video.addEventListener(
      "play",
      function () {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        newdraw(video, context, canvas.width, canvas.height);
      },
      false,
    );

    function draw(video, context, width, height) {
      if (video.paused || video.ended) return false;
      context.drawImage(video, 0, 0, width, height);
      var imageData = context.getImageData(0, 0, width, height);
      var data = imageData.data;
      for (var i = 0; i < data.length; i += 4) {
        var r = data[i];
        var g = data[i + 1];
        var b = data[i + 2];
        // Modify these values to better suit the green you need to remove
        if (g > 100 && r < 150 && b < 150) data[i + 3] = 0; // Set alpha to 0
      }
      context.putImageData(imageData, 0, 0);
      setTimeout(draw, 20, video, context, width, height);
    }

    function newdraw(video, context, width, height) {
      if (video.paused || video.ended) return false;
      context.drawImage(video, 0, 0, width, height);
      var imageData = context.getImageData(0, 0, width, height);
      var data = imageData.data;

      // Define the target green screen color
      var targetR = 0;
      var targetG = 255;
      var targetB = 0;

      // Tolerance for color matching (lower is more strict)
      var tolerance = 300;

      for (var i = 0; i < data.length; i += 4) {
        var r = data[i];
        var g = data[i + 1];
        var b = data[i + 2];

        // Calculate the color distance between the current pixel and the target color
        var distance = Math.sqrt(Math.pow(r - targetR, 2) + Math.pow(g - targetG, 2) + Math.pow(b - targetB, 2));

        // If the distance is less than the tolerance, make the pixel transparent
        if (distance < tolerance) {
          data[i + 3] = 0; // Set alpha to 0
        }
      }
      context.putImageData(imageData, 0, 0);
      setTimeout(draw, 20, video, context, width, height);
    }
  },
};
</script>

<style>
canvas {
  width: 100%;
  height: 100%;
}
</style>
